package app.bloomey.web.modules.users

import com.copperleaf.ballast.InputHandler
import com.copperleaf.ballast.InputHandlerScope
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.flow.collectLatest

class UsersInputHandler : InputHandler<
        UsersContract.Inputs,
        UsersContract.Events,
        UsersContract.State> {

    private val repository = UsersRepository()
    override suspend fun InputHandlerScope<
            UsersContract.Inputs,
            UsersContract.Events,
            UsersContract.State>.handleInput(
        input: UsersContract.Inputs,
    ): Unit = when (input) {
        is UsersContract.Inputs.GetUsers -> {
            coroutineScope {
                repository.getUsers(page = input.page, size = input.size, query = input.query).collectLatest { state ->
                    updateState {
                        it.copy(usersState = state, page = input.page)
                    }
                }
            }
        }

        is UsersContract.Inputs.UpdateUser -> {
            repository.updateUser(input.id, input.request).collectLatest { state ->
                updateState {
                    it.copy(updateUser = state)
                }
            }
        }

        is UsersContract.Inputs.DeleteUsers -> {
            repository.deleteUsers(input.idList).collectLatest { state ->
                updateState {
                    it.copy(deleteUsers = state)
                }
            }
        }

        is UsersContract.Inputs.DeleteUser -> {
            repository.deleteUser(input.id).collectLatest { state ->
                updateState {
                    it.copy(deleteUser = state)
                }
            }
        }

        is UsersContract.Inputs.GetUser -> {
            repository.getUser(input.userId).collectLatest { state ->
                updateState {
                    it.copy(getUser = state)
                }
            }
        }
    }
}
